import request from '../router/axios'
import service from "@/router/request";

// 默认的
const loginuserid = 'e1320d1ebc224679b22fc1607d03bda7';
const projectId = '6f835ebee23a43d98b1f32c69eaf9e7d';
// ~~~~~~~~~~~~~~~~~全国屏接口~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// 初始化token
export function getInitAccessToken(data) {
    return service({
        url: `/holdMy/getInitAccessToken`,
        method: 'post',
        headers: {
            isToken: false
        },
        data: data
    })
}

export function login(username, password, code, uuid) {
    const data = {
        username,
        password,
        code,
        uuid
    }
    return service({
        url: '/login',
        headers: {
            isToken: false,
            repeatSubmit: false
        },
        method: 'post',
        data: data
    })
}
// 获取验证码
export function getCodeImg() {
    return request({
        url: '/captchaImage',
        headers: {
            isToken: false
        },
        method: 'get',
        timeout: 20000
    })
}
// 刷新token
export function getAccessToken(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/holdMy/getAccessToken`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}


// 101.主界面数据接口
export function getMainList(params) {
    return request({
        url: `/jn/bd/list`,
        method: 'get',
        headers: {
            serialize: true
        },
        params: params
    })
}
// 新增备选站点
export function addAlternativeSites(data) {
    return request({
        url: '/jn/alternativeSites',
        method: 'post',
        data: data
    })
}
// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
        url: '/system/dict/data/type/' + dictType,
        method: 'get'
    })
}
// 获取全部备选站点
export function getAllAlternativeSites(data) {
    return request({
        url: '/jn/alternativeSites/list',
        method: 'get',
        data: data
    })
}